module.exports = __webpack_public_path__ + "static/media/banner-svgrepo-com.7cca1111.svg";